<template>
  <v-container
    fluid
    class="customer-details-page ops-entry-form-page ops-entry-form-page--customer ops-entry-form-page--edit"
  >
    <v-card raised class="customer-details-card ops-entry-form-card">
      <loading :active.sync="loading" />
      <v-card-title class="bg-clr ops-entry-form-hero customer-details-hero">
        <div class="ops-entry-form-hero__main">
          <v-btn
            fab
            flat
            icon
            class="nospace ops-entry-form-back"
            @click.native="goback"
          >
            <v-icon class="pointer" v-ripple>arrow_back</v-icon>
          </v-btn>
          <div class="ops-entry-form-title-block">
            <div class="ops-entry-form-title-row">
              <span class="headline ops-entry-form-title">
                {{ customerDetails.name }}
                <span v-if="customerDetails.companyName">
                  ({{ customerDetails.companyName }})
                </span>
              </span>
            </div>
            <div v-if="customerDetails.email" class="ops-entry-form-subtitle">
              {{ customerDetails.email }}
            </div>
          </div>
        </div>
      </v-card-title>
      <v-card-text class="customer-details-body content-border">
        <v-tabs class="m-b-20 customer-details-tabs" v-model="changeTabListing">
          <v-tab
            :href="`#basicDetail`"
            class="customer-details-tab"
            @click="filterByTab('basicDetail')"
          >
            <v-icon small class="customer-details-tab__icon">
              person_outline
            </v-icon>
            <span class="customer-details-tab__label">Basic Details</span>
          </v-tab>
          <v-tab
            :href="`#bookings`"
            class="customer-details-tab"
            @click="filterByTab('bookings')"
          >
            <v-icon small class="customer-details-tab__icon">
              work_outline
            </v-icon>
            <span class="customer-details-tab__label">Booking</span>
            <span v-if="totalJobCount > 0" class="customer-details-tab__count">
              {{ totalJobCount }}
            </span>
          </v-tab>
          <v-tab
            :href="`#sales`"
            class="customer-details-tab"
            @click="filterByTab('sales')"
          >
            <v-icon small class="customer-details-tab__icon">
              assignment
            </v-icon>
            <span class="customer-details-tab__label">Inquiry</span>
            <span v-if="totalSalesCount > 0" class="customer-details-tab__count">
              {{ totalSalesCount }}
            </span>
          </v-tab>
        </v-tabs>

        <div class="customer-details-view">
          <EditCustomer
            v-if="changeTabListing == 'basicDetail' && customerDetails._id"
            :customer-profile="customerDetails"
          />
          <CustomerJobListing
            :searchText="search"
            :tabListFilter="changeTabListing"
            :countryFilter="country"
            :reset="reset"
            :loader="loading"
            v-on:on-block="refreshActivity"
            v-on:on-load="startLoad"
            v-on:off-load="stopLoad"
            v-on:totalDataJob="totalDataJob"
            :customerId="custId"
            :userId="userId"
            v-if="changeTabListing == 'bookings'"
          />
          <CustomerSaleListing
            :searchText="search"
            :tabListFilter="changeTabListing"
            :countryFilter="country"
            v-on:totalDataSales="totalDataSales"
            :reset="reset"
            :loader="loading"
            v-on:on-block="refreshActivity"
            v-on:on-load="startLoad"
            v-on:off-load="stopLoad"
            :customerId="custId"
            :userId="userId"
            v-if="changeTabListing == 'sales'"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { EventBus } from "../../event-bus.js";
import Dashboard from "./Dashboard";
import CustomerList from "./CustomerList";
import CustomFilter from "./CustomFilter";
import CustomerJobListing from "./CustomerJobListing";
import CustomerSaleListing from "./CustomerSaleListing";
import EditCustomer from "./EditCustomer";
import CreditLimit from "./CreditLimit";
import moment from "moment";
import Loading from "vue-loading-overlay";
import { StorageKeys } from "../../constants/constants";
import { custDetails } from "../../constants/api-urls";
export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      let workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          this.invoicingCountry = key.value;
        }
      });
    }
    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "customer-details") {
        this.$router.push(`/customers`);
      }
    });
    this.$eventBus.$on("customer-details", () => {
      this.bookingDetails = !this.bookingDetails;
    });

    this.getCustomer();
    (this.custId = this.$route.params.id),
      (this.userId = this.$route.params.userId),
      this.$eventBus.$on("close-job-profile", () => {
        this.dialog = false;
      });

    this.$eventBus.$on("customer-details-count", (data) => {
      if (data) {
        this.userId = data._id;
        this.bookingCount = data.totalBookings;
        this.inquiryCount = data.totalInquiry;
      }
    });

    this.$eventBus.$on("on-load", () => {
      this.loading = true;
    });

    this.$eventBus.$on("off-load", () => {
      this.loading = false;
    });
    localStorage.removeItem("paginationUrlJob");
  },

  mounted() {
    if (localStorage.getItem("changeBasicTabListing") != null) {
      this.changeTabListing = localStorage.changeBasicTabListing;
    } else {
      if (localStorage.getItem("changeTabListing") != null) {
        this.changeTabListing = localStorage.changeTabListing;
      } else {
        this.changeTabListing = "bookings";
      }
    }
  },
  components: {
    Dashboard,
    CustomerList,
    CustomFilter,
    Loading,
    CustomerJobListing,
    CustomerSaleListing,
    EditCustomer,
    CreditLimit,
  },

  data: () => ({
    search: "",
    country: "",
    bookingDetails: false,
    dashboard: {
      today: 0,
      total: 0,
    },
    active: "0",
    totalJobCount: "",
    totalSalesCount: "",
    dialog: false,
    reset: false,
    loading: true,
    changeTabListing: "bookings",
    customerDetails: {},
    custId: "",
    userId: "",
    bookingCount: null,
    inquiryCount: null,
  }),
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getCustomer() {
      this.loading = true;
      let url = custDetails;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        userId: this.$route.params.id,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.userId = response.data.data._id;
          this.customerDetails = response.data.data;
          this.custId = this.customerDetails.userId.toString();
        },
        (error) => {
          this.x.error = "Failed to Fetch User Details";
        }
      );
    },
    filterByTab(value) {
      localStorage.setItem("changeTabListing", value);
      this.changeTabListing = value;
    },
    refreshActivity() {
      this.reset = true;
    },
    startLoad() {
      this.loading = true;
    },
    totalDataJob(e) {
      this.totalJobCount = e;
    },
    totalDataSales(e) {
      console.log(e);
      this.totalSalesCount = e;
    },
    stopLoad() {
      this.loading = false;
    },
    resetCustomer() {
      this.reset = true;
      this.search = "";
    },
    dashboardData(event) {
      this.dashboard.total = event.totalData;
      this.dashboard.today = event.todayData;
      this.loading = false;
    },
    searchText(event) {
      this.search = event;
      this.reset = false;
    },
    countryFilter(event) {
      this.country = event;
      this.reset = false;
    },
  },
};
</script>

<style scoped>
.m-b-20 {
  margin-bottom: 20px !important;
}
</style>
